export default __webpack_public_path__ + "static/graphik-regular-web-98fc5c36053d67b35c699105232d31ce.woff";